import { render } from "./BaseMultiselect.vue?vue&type=template&id=26b479bc&scoped=true"
import script from "./BaseMultiselect.vue?vue&type=script&lang=js"
export * from "./BaseMultiselect.vue?vue&type=script&lang=js"

import "./BaseMultiselect.vue?vue&type=style&index=0&id=26b479bc&lang=scss&scoped=true"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b479bc"]])

export default __exports__